// firestore-paths.ts - helpers d'identifiants et de chemins Firestore.
import type { Service } from './types';

export const COLLECTIONS = {
  villes: 'villes',
  restos: 'restos',
  dispos: 'dispos',
  demandes: 'demandes',
  stats_mensuelles: 'stats_mensuelles',
  leads: 'leads',
  /** Compteurs publics du module Calendrier (docs/rules/calendrier.md). */
  calendrier: 'calendrier',
  /**
   * Historique NOMINAL des réservations confirmées, conservé 3 ans puis
   * anonymisé (docs/rules/historique-reservations.md). Lecture réservée au
   * restaurateur propriétaire ; écriture Admin SDK uniquement.
   */
  reservations: 'reservations',
  /**
   * Photographies nocturnes du remplissage des dates futures
   * (docs/rules/previsions-ia.md). Écriture Admin SDK, lecture owner.
   */
  previsions: 'previsions',
  /**
   * Agrégats CLIENT anonymes du réseau (docs/rules/clients-agreges.md).
   * Écriture Admin SDK, lecture admin uniquement - jamais un restaurateur.
   */
  clients: 'clients',
} as const;

/**
 * Sous-collection PRIVÉE du plan de salle : `restos/{restoId}/plan/{zid}`
 * (docs/rules/plan-salle.md). Un document par zone ; lecture/écriture
 * restaurateur propriétaire et admin uniquement - jamais l'app cliente.
 */
export const PLAN_SUBCOLLECTION = 'plan';

/**
 * Sous-collection PRIVÉE des appareils du restaurateur :
 * `restos/{restoId}/appareils/{appareilId}` (docs/rules/notifications-resto.md).
 * Un document par appareil ayant accepté les notifications - téléphone,
 * tablette du comptoir, ordinateur du bureau. Lecture/écriture restaurateur
 * propriétaire et admin uniquement : un jeton FCM est une adresse d'envoi,
 * jamais public.
 */
export const APPAREILS_SUBCOLLECTION = 'appareils';

/** ID composite d'un document dispo (spec v1.2) : `{resto_id}_{date}_{service}`. */
export function dispoId(restoId: string, date: string, service: Service): string {
  return `${restoId}_${date}_${service}`;
}

/** Inverse de dispoId : extrait { restoId, date, service } d'un ID composite. */
export function parseDispoId(
  id: string,
): { restoId: string; date: string; service: Service } | null {
  const m = /^(.+)_(\d{4}-\d{2}-\d{2})_(midi|soir)$/.exec(id);
  if (!m) return null;
  return { restoId: m[1], date: m[2], service: m[3] as Service };
}

/** ID d'un document stats mensuelles : `{resto_id}_{mois}` (mois = "2026-06"). */
export function statsMensuellesId(restoId: string, mois: string): string {
  return `${restoId}_${mois}`;
}

/** ID d'un document compteurs calendrier : `{resto_id}_{date}`. */
export function calendrierId(restoId: string, date: string): string {
  return `${restoId}_${date}`;
}

/** ID d'un document prévisions : `{resto_id}_{date_cible}`. */
export function previsionId(restoId: string, date: string): string {
  return `${restoId}_${date}`;
}
